import './cta-button.scss'
import type { CmsLink } from '@omnia/ui/src/lib'
import { CmsLinkComponent } from '@omnia/ui/src/lib/cms/components/cmsLink/CmsLink'
import type { FC, ReactNode } from 'react'
import type { CtaButtonPropsApi } from '@/common/components/ctaButton/models'
import type { ButtonColorPicker } from '@/common/model_builder/colorPickers/buttonColorPicker'
import { cx } from '@/common/utils/className'

/**
 * DevNote: This is basically a cta-link, but it called a button on cms, so we have to align with that
 * */
interface ButtonProps extends Omit<CtaButtonPropsApi, 'alignment' | 'buttonColor'> {
    children?: ReactNode
    buttonColor?: ButtonColorPicker
    link: CmsLink
    onClick?: () => void
    className?: string
}

export const CtaButton: FC<ButtonProps> = props => {
    const { link, children, onClick, className } = props ?? {}
    const { label = 'black' } = props.buttonColor ?? {}
    const cls = cx('cta-button', label, className)

    return (
        <CmsLinkComponent link={link} className={cls} onClick={onClick}>
            {!children && <div className="text-wrapper">{link.name}</div>}
        </CmsLinkComponent>
    )
}
